module.exports = __webpack_public_path__ + "img/3.9d88c6ff.png";